import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=727a0140&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('727a0140')) {
      api.createRecord('727a0140', component.options)
    } else {
      api.reload('727a0140', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=727a0140&", function () {
      api.rerender('727a0140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2um1A7Cx97CKh/JS/comp/IncreaseNumber.vue"
export default component.exports